<template>
  <div class="language-switcher" @click="toggleLanguage">
    <img src="/images/icon1.png" :alt="t('login.language')" class="globe-icon" />
    <span>{{ currentLanguage }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Message } from '@arco-design/web-vue'

const { t, locale } = useI18n()

// 当前语言显示
const currentLanguage = computed(() => {
  return locale.value === 'zh-CN' ? '简体中文' : 'English'
})

// 切换语言
const toggleLanguage = () => {
  const newLocale = locale.value === 'zh-CN' ? 'en-US' : 'zh-CN'
  locale.value = newLocale
  localStorage.setItem('locale', newLocale)
  Message.success(t('message.languageSwitched'))
}
</script>

<style scoped lang="less">
.language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #1890ff;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    color: #40a9ff;
    background: rgba(24, 144, 255, 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  .globe-icon {
    width: 16px;
    height: 16px;
  }
}
</style>

